export default __webpack_public_path__ + "static/media/notes.983447c1.svg";